var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoubleChevronRight(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.96967 3.96967C4.26256 3.67678 4.73732 3.67678 5.03022 3.96967L9.53022 8.46967C9.82305 8.76257 9.82309 9.23734 9.53022 9.53022L5.03022 14.0302C4.73734 14.3231 4.26257 14.3231 3.96967 14.0302C3.67678 13.7373 3.67678 13.2626 3.96967 12.9697L7.9394 8.99994L3.96967 5.03022C3.67678 4.73732 3.67678 4.26256 3.96967 3.96967ZM8.46967 3.96967C8.76256 3.67678 9.23732 3.67678 9.53022 3.96967L14.0302 8.46967C14.3231 8.76257 14.3231 9.23734 14.0302 9.53022L9.53022 14.0302C9.23734 14.3231 8.76257 14.3231 8.46967 14.0302C8.17678 13.7373 8.17678 13.2626 8.46967 12.9697L12.4394 8.99994L8.46967 5.03022C8.17678 4.73732 8.17678 4.26256 8.46967 3.96967Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoubleChevronRight);
export default __webpack_public_path__ + "static/media/double-chevron-right.46218890db4d2b7bb6b2e9d14d7c22ae.svg";
export { ForwardRef as ReactComponent };